import React from "react";
import styles from "./GuestRsvpDetails.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import { CalendarIcon, ClockIcon, LocIcon, UserIcon } from "../../../../components/icons/Icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
const GuestRsvpDetails = () => {
   const EventDetails = useSelector(
  (state) => state?.GuestReducer?.EventDetails
);
    const navigate = useNavigate();
  return (
    <div className={styles.mainCont}>
      <div className={styles.detailsDiv}>
        <div className={styles.details}>
          <TextComponent
            text={"Wedding details"}
            textClass={styles.detailsHeading}
          />
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <LocIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Location:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent text={EventDetails?.address} />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <CalendarIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Date:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(EventDetails?.date).format("MMMM DD, yyyy")}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <UserIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Guests:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={`${EventDetails?.no_of_attendee}/${EventDetails?.no_of_guest}`}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <ClockIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Start Time"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(EventDetails?.start_time).format("hh:mm a")}
              />
            </div>
          </div>
        </div>
        <div className={styles.details}>
          <TextComponent
            text={"Reception details"}
            textClass={styles.detailsHeading}
          />
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <LocIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Location:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent text={EventDetails?.reception_address} />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <CalendarIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Date:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(EventDetails?.date).format("MMMM DD, yyyy")}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <UserIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Guests:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={`${EventDetails?.no_of_attendee}/${EventDetails?.no_of_guest}`}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.underDetails}>
              <div className={styles.subLeft}>
                <ClockIcon size={20} className={styles.locationIcon} />
                <TextComponent text={"Start Time"} />
              </div>
              <div className={styles.subright}>
                <TextComponent
                  text={moment(EventDetails?.reception_start_time).format(
                    "hh:mm a"
                  )}
                />
              </div>
            </div>
            <div className={styles.underDetails}>
              <div className={styles.subLeft}>
                <ClockIcon size={20} className={styles.locationIcon} />
                <TextComponent text={"End Time"} />
              </div>
              <div className={styles.subright}>
                <TextComponent
                  text={moment(EventDetails?.reception_end_time).format(
                    "hh:mm a"
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.floorbtnDiv}>
      <SubmitButton
            title="View Floor Plan"
            outline
            btnClass={styles.floorbtn}
            onClick={()=>navigate("/floorPlan",{
                state: {headrTitle: "RSVP"}
            })}
            
          />
      </div>
      <div className={styles.btnDiv}>
      <SubmitButton
            title="Next"
            btnClass={styles.btn}
            onClick={()=>navigate("/RsvpTidbits", {
                state: {headrTitle: "RSVP"}
            })}
            
          />
      </div>
    </div>
  );
};

export default GuestRsvpDetails;
